export default class UserError extends Error {
  constructor(message, data = null) {
    super(message)
    this.name = 'UserError'
    this.data = data
  }
}
